/**
 *
 * Usage:
 *
 *   data-sw-model-posing-type-aopt=porcelain
 *   Uses a combination of mouseenter, mouseleave, and blur to capture a
 *   click on the AOPT viewers (iframes).
 *
 *   We are testing how often users are changing their positioning before saving. Once that
 *   test is over, this code should be reevaluated.
 *
 *   TODO: Once our test is over, we should decide whether this code should be maintained or
 *   removed.
 */

var $ = require('js/sw-jquery/sw-jquery');

var SELECTORS = {
  porcelainModelPosing: '[data-sw-model-posing-type-aopt=porcelain]',
  porcelainModelPosingBtn: '[data-sw-model-posing-type-save-btn="porcelain"]'
};

$(function() {
    $('body').on('mouseenter', SELECTORS.porcelainModelPosing, function() {
        $(window).on('blur', function() {
          $(SELECTORS.porcelainModelPosingBtn).data('swTrackingDefaultOrientation', false);
        });
    });

    $('body').on('mouseleave', SELECTORS.porcelainModelPosing, function() {
        $(window).off('blur');
    });
});
